import * as React from 'react';
import * as styles from './styles.css';

import { Label, ILabelProps } from '@cian/ui-kit';

import { IconFunctionalWarningSign16, IconFinanceSale16 } from '@cian/ui-kit-design-tokens/icons';

export type TStatusLabelTheme = 'warning' | 'default';

interface IStatusLabelProps {
  onClick(): void;
  theme: TStatusLabelTheme;
  text: string;
}

export const StatusLabel: React.FC<IStatusLabelProps> = ({ theme, onClick, text }) => {
  const Icon = theme === 'default' ? IconFinanceSale16 : IconFunctionalWarningSign16;
  const iconColor = theme === 'default' ? 'icon-secondary-default' : 'accent-warning-primary';
  const iconBg = theme === 'default' ? 'gray6_100' : 'surface-warning-default';
  const textColor = theme === 'default' ? 'theme-dark' : 'accent-warning-primary';

  return (
    <div className={styles['container']}>
      <Label
        onClick={onClick}
        color={textColor as ILabelProps['color']}
        background={iconBg as ILabelProps['background']}
        icon={<Icon color={iconColor} />}
      >
        {text}
      </Label>
    </div>
  );
};

StatusLabel.displayName = 'StatusLabel';
